// The role fields that belong to whoever holds the role, not to the
// organisation's governance: the recurring actions they tick off, the numbers
// they watch, and their own scratchpad. They describe how someone does the job,
// never what the job is — so a strict governance mode has no reason to freeze
// them, and their holder edits them in every mode (GOUV-15, 08/08/2026, see
// docs/features/gouv-bloc-gouvernance.md).
//
// The structural fields (purpose, domain, accountabilities, and the role's
// name) stay subject to the governance mode: they define the role itself.
//
// This list is the single place naming them. The webapp gates the fields with
// it and the backend whitelists writes with it, so the screen and the server
// cannot drift apart.
export const ROLE_WORK_FIELDS = ['checklist', 'indicators', 'notes'] as const

export type RoleWorkField = (typeof ROLE_WORK_FIELDS)[number]

export function isRoleWorkField(field: string): field is RoleWorkField {
  return (ROLE_WORK_FIELDS as readonly string[]).includes(field)
}
